export enum NotificationCategory {
  BALANCE = 'BALANCE',
  BONUS = 'BONUS',
  ACCOUNT = 'ACCOUNT',
  ERROR = 'ERROR',
  GAME = 'GAME',
  SYSTEM = 'SYSTEM',
}
